import { defineComponent as _defineComponent } from 'vue'
import FieldMap from '@/components/field-view-next/mapbox/FieldMap.vue'
import SinglePointPin from '@/components/field-view-next/layers/SinglePointPin.vue'
import { pointToLatLng, pointToMapData } from '@/utils/forms/point-helper'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmissionLatLngField',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as { value: string }



const latLng = computed(() => pointToLatLng(props.value))
const data = computed(() => pointToMapData(props.value))

return { __sfc: true,props, latLng, data, FieldMap, SinglePointPin }
}

})